// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/fonts/hanzipen-sc-bold.otf");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, "@font-face{font-family:HanziPen SC;src:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");font-weight:400}.bl_root{background-color:#f9f9f9;font-family:\"Montserrat\",sans-serif;font-style:normal;font-weight:normal;font-size:16px;line-height:20px}", ""]);
// Exports
module.exports = exports;
